/**
 * these are the (untranslated) errors the backend API returns if something goes wrong
 */
export enum BackendRequestErrors {
  AccessDenied = "Access Denied.",
  BadRequest = "Bad Request",
  NotFound = "Not Found",
}

/**
 * Other request related errors, not necessarily coming from the backend.
 * May occur e.g. in tests, if the local axios api is not mocked.
 */
export enum OtherRequestErrors {
  NoNetworkResponse = "failure.noNetworkResponse",
  FailureSendingRequest = "failure.sendingRequest",
  MissingDataFromApi = "error.missingDataFromApi",
}

/**
 * this are the translateable messages we use when throwing an Error
 */
export enum RequestErrorTranslations {
  AccessDenied = "explanation.403",
  BadRequest = "explanation.500",
  NotFound = "explanation.404",
}

/**
 * we use this error subclass when the client encounters an error sending a request to the API
 * (not when a request received a response which contained an error!), for logging & retry purposes
 */
export class RequestError extends Error { }

export const translateRequestError = (msg: BackendRequestErrors): string => {
  switch (msg) {
    case BackendRequestErrors.AccessDenied: return RequestErrorTranslations.AccessDenied
    case BackendRequestErrors.BadRequest: return RequestErrorTranslations.BadRequest
    case BackendRequestErrors.NotFound: return RequestErrorTranslations.NotFound
    default: return msg
  }
}